export default {
    type: "FeatureCollection",
    features: [{
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3934504, 43.6560121],
            },
            properties: {
                name: "BALDWIN + HENRY ST",
                img: "lassen-reducing-human-emissions.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.4313173, 43.6528397],
            },
            properties: { name: "COLLEGE + RUSHOLME" },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.4121796, 43.6654005],
            },
            properties: { name: "BLOOR + LIPPINCOTT" },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.4033692, 43.6646188],
            },
            properties: {
                name: "SPADINA + SUSSEX",
                img: "lassen-climate-change-affects-people-differently.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.4273621, 43.6538644],
            },
            properties: {
                name: "COLLEGE + DELAWARE",
                img: "lassen-seasonal-availability-of-freshwater.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3997505, 43.6576703],
            },
            properties: {
                name: "COLLEGE + SPADINA",
                img: "lassen-violence-against-the-earth.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3510161, 43.6894177],
            },
            properties: {
                name: "PAPE + COSBURN",
                img: "lassen-violence-against-the-earth.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3473918, 43.6671084],
            },
            properties: {
                name: "GERRARD EAST + LOGAN",
                img: "lassen-climate-change-affects-people-differently.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.2989783, 43.6893121],
            },
            properties: {
                name: "DANFORTH + DAWES RD",
                img: "lassen-reducing-human-emissions.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.5126911, 43.6245898],
            },
            properties: {
                name: "QUEENSWAY + CHARTWELL",
                img: "lassen-seasonal-availability-of-freshwater.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3937705, 43.6475685],
            },
            properties: {
                name: "ADELAIDE + WIDMER",
                img: "lassen-logging-scars.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.4331435, 43.6747102],
            },
            properties: {
                name: "DAVENPORT + OSSINGTON",
                img: "lassen-logging-scars.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.4509948, 43.6570632],
            },
            properties: { name: "PERTH + BLOOR", img: "lassen-logging-scars.jpg" },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.4354546, 43.6377347],
            },
            properties: {
                name: "KING + DUNN",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.4431246, 43.639749],
            },
            properties: {
                name: "SORAUREN + QUEEN",
                img: "lassen-climate-change-affects-people-differently.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.274939, 43.686528],
            },
            properties: {
                name: "KINGSTON RD + CORNELL AVE",
                img: "lassen-logging-scars.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3672917, 43.6526694],
            },
            properties: {
                name: "ADELAIDE + ONTARIO",
                img: "lassen-violence-against-the-earth.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3760771, 43.6553759],
            },
            properties: {
                name: "JARVIS + SHUTER",
                img: "lassen-seasonal-availability-of-freshwater.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3666369, 43.6556001],
            },
            properties: {
                name: "PARLIAMENT + QUEEN",
                img: "lassen-reducing-human-emissions.jpg",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: [-79.3800132, 43.6581909],
            },
            properties: {
                name: "CHURCH + GOULD",
                img: "lassen-logging-scars.jpg",
            },
        },
    ],
};